/** Returns the origin of an absolute URL, or `null` if it can't be parsed. */
export function safeOrigin(value: unknown): string | null {
  if (typeof value !== 'string' || value.length === 0) {
    return null;
  }

  try {
    return new URL(value).origin;
  } catch {
    console.error('[trusted-origin] Invalid trusted API URL, ignoring:', value);
    return null;
  }
}

interface IRequestTarget {
  url?: string;
  baseURL?: string;
}

/**
 * Builds a predicate gating which requests may carry credentials — auth tokens
 * and tenant-origin headers must reach a trusted origin only, never a foreign one.
 */
export function createTrustedOriginChecker(trustedOrigins: Set<string>) {
  return function isTrustedRequest(config: IRequestTarget): boolean {
    try {
      // Anchor a relative baseURL to the page origin so URL() can resolve it.
      const base = config.baseURL
        ? new URL(config.baseURL, window.location.origin).href
        : window.location.origin;
      const resolved = new URL(config.url ?? '', base);
      return trustedOrigins.has(resolved.origin);
    } catch {
      return false;
    }
  };
}
